export function IconZapbot({
  size = 24,
  color = "#FF4F00",
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7553 12.5743C23.5364 12.0457 23.0673 11.9189 22.7499 11.8886V8.66675C22.7499 7.47183 21.7782 6.50008 20.5833 6.50008H14.0833V4.99425C14.4137 4.69741 14.6249 4.27058 14.6249 3.79175C14.6249 3.36077 14.4537 2.94745 14.149 2.6427C13.8442 2.33795 13.4309 2.16675 12.9999 2.16675C12.569 2.16675 12.1556 2.33795 11.8509 2.6427C11.5461 2.94745 11.3749 3.36077 11.3749 3.79175C11.3749 4.27058 11.5862 4.69741 11.9166 4.99425V6.50008H5.41659C4.22168 6.50008 3.24993 7.47183 3.24993 8.66675V11.9135L3.16109 11.92C2.88807 11.9397 2.63262 12.062 2.44611 12.2624C2.25961 12.4628 2.15587 12.7263 2.15576 13.0001V15.1667C2.15576 15.4541 2.2699 15.7296 2.47306 15.9328C2.67623 16.1359 2.95178 16.2501 3.23909 16.2501H3.24993V21.6667C3.24993 22.8617 4.22168 23.8334 5.41659 23.8334H20.5833C21.7782 23.8334 22.7499 22.8617 22.7499 21.6667V16.2501C23.0372 16.2501 23.3128 16.1359 23.516 15.9328C23.7191 15.7296 23.8333 15.4541 23.8333 15.1667V13.0672C23.8457 12.8991 23.819 12.7304 23.7553 12.5743ZM5.41659 21.6667V8.66675H20.5833L20.5843 12.9957L20.5833 13.0001V15.1667L20.5843 15.1722L20.5854 21.6667H5.41659Z"
        fill={color}
      />
      <path
        d="M9.20825 15.1666C10.1057 15.1666 10.8333 14.1965 10.8333 12.9999C10.8333 11.8033 10.1057 10.8333 9.20825 10.8333C8.31079 10.8333 7.58325 11.8033 7.58325 12.9999C7.58325 14.1965 8.31079 15.1666 9.20825 15.1666Z"
        fill={color}
      />
      <path
        d="M16.7917 15.1666C17.6892 15.1666 18.4167 14.1965 18.4167 12.9999C18.4167 11.8033 17.6892 10.8333 16.7917 10.8333C15.8943 10.8333 15.1667 11.8033 15.1667 12.9999C15.1667 14.1965 15.8943 15.1666 16.7917 15.1666Z"
        fill={color}
      />
      <path
        d="M8.66675 17.3333H17.3334V19.4999H8.66675V17.3333Z"
        fill={color}
      />
    </svg>
  );
}
